import { Component, Inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { IWidgetProviderService, WIDGET_PROVIDER_SERVICE } from 'src/app/interfaces';
import { AbstractWidgetInner } from 'src/app/widget-inner';

@Component({
  selector: 'app-i-frame-widget-inner',
  templateUrl: './i-frame-widget-inner.component.html',
  styleUrls: ['./i-frame-widget-inner.component.css']
})
export class IFrameWidgetInnerComponent extends AbstractWidgetInner {

  href = this._sanitizer.bypassSecurityTrustResourceUrl('https://www.complan-und-service.de/');

  constructor(
    @Inject(WIDGET_PROVIDER_SERVICE) private _widgetComponentService: IWidgetProviderService,
    private _sanitizer: DomSanitizer
  ) {
    super();
  }
  
  ngOnInit(): void {
    let href = this._widgetComponentService.iFrameViews[0];
    if(typeof href === 'string') this.href = this._sanitizer.bypassSecurityTrustResourceUrl(href);
  }

  receiveIFrame = (href: string) => this.href = this._sanitizer.bypassSecurityTrustResourceUrl(href);

}
